module.exports = "../../static/img/cardTitle.cea12bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile/cardTitle.png
// module id = 1n67
// module chunks = 1